import(/* webpackMode: "eager" */ "/home/app/workspace/app/error.tsx");
